/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M0 0v3c0 .5523.4477 1 1 1s1-.4477 1-1V2h3.6667c.5523 0 1-.4477 1-1s-.4477-1-1-1H0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 7c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5Zm-3 5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.9996 3c-1.8866 0-3.785.3785-5.6507 1.5403C4.4963 5.694 2.7505 7.5735 1.0774 10.451L.1766 12l.9008 1.5491.0035.006.2943.4982.0036.0061c1.6317 2.7173 3.3356 4.4718 5.1432 5.5384C8.3393 20.6703 10.1813 21 11.9996 21c1.8866 0 3.785-.3785 5.6507-1.5403 1.8525-1.1537 3.5984-3.0332 5.2715-5.9106l.9027-1.5523-1.1971-2.0442-.0056-.0095c-1.6324-2.7184-3.3366-4.4736-5.1443-5.5406C15.6599 3.3298 13.8179 3 11.9996 3Zm-9.1933 8.4562c1.564-2.6895 3.1041-4.2867 4.5998-5.2181C8.8887 5.3148 10.4007 5 11.9996 5c1.561 0 3.0279.2789 4.4613 1.1249 1.4422.8512 2.9299 2.3238 4.4435 4.8431l.6045 1.0323-.316.5435c-1.5639 2.6895-3.1042 4.2867-4.5999 5.2181C15.1105 18.6852 13.5985 19 11.9996 19c-1.5611 0-3.028-.2789-4.4612-1.1246-1.4424-.8512-2.93-2.3235-4.4431-4.8425l-.2907-.4921L2.49 12l.3162-.5438Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M24 21v3h-5.6667c-.5523 0-1-.4477-1-1s.4477-1 1-1H22v-1c0-.5523.4477-1 1-1s1 .4477 1 1Z"
    />
  </React.Fragment>,
  'MenuPreview'
);
